<template>
  <div>
    <BaseFrame
      clear-text=""
      cancel-text="取消"
      submit-text="提交"
      :submit-loading="submitLoading"
      @cancel="clear"
      @submit="saveBreakageData">
      <div slot="content">
        <lk-card title="报损申请信息">
          <lk-form :label-width="120" ref="form" :model="breakageModel" :rules="breakageRules">
            <lk-row :gutter="16">
              <lk-col span="10">
                <lk-form-item label="报损时间:" prop="scrapTime">
                  <timeStampDatePicker class="item" v-model="breakageModel.scrapTime" :options="disabledFromToday"></timeStampDatePicker>
                </lk-form-item>
              </lk-col>
              <lk-col offset="2" span="10">
                <lk-form-item label="不合格商品:">
                  <lk-button type="primary" @click="handleAddGoods">新增</lk-button>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="22">
                <lk-form-item>
                  <div class="requireBreakAdd">
                    <lk-table border :columns="columns" :data="tableData"></lk-table>
                  </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </BaseFrame>
    <lk-modal
      v-model="showModal"
      title="报损商品"
      width="800">
      <div class="queryContainer">
        <div class="queryItem">
          <goodsSearchItem v-model="modalQueryParams.nameMix"></goodsSearchItem>
        </div>
        <div class="queryItem">
          <label>不合格单号:</label>
          <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="modalQueryParams.unqualifiedApplyCode"></lk-input>
        </div>
        <div>
          <label>报损申请状态:</label>
           <lk-select v-model="model1" class="selectCon" @on-change='handlerchange'>
              <lk-option v-for="item in applyStatusList" :value="item.value" :key="item.value">{{ item.label }}</lk-option>
           </lk-select>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="mr8" @click="getInventoryData">查询</lk-button>
          <lk-button @click="clearModalQuery">重置</lk-button>
        </div>
      </div>
      <div style="position: relative;">
        <loading v-show="modalLoading"></loading>
        <lk-table
          border
          :columns="modalColumns"
          :data="modalTableData"
          @on-select="handleTempSelect"
          @on-select-cancel="handleTempCancel"
          @on-select-all="handleSelectAll"
          @on-select-all-cancel="handleSelectAllCancel">
        </lk-table>
        <div class="paging">
          <lk-page :total="count" :current.sync='page' @on-change="changePage"></lk-page>
        </div>
      </div>
      <div slot="footer">
        <div class="queryItem">
          <!-- <span class="mr8">已选:{{this.tempGoods.length + this.tableData.length}}项</span> -->
          <span class="mr8">已选:{{this.tempGoods.length}}项</span>
          <lk-button @click="clearModal">取消</lk-button>
          <lk-button type="primary" class="mr" @click="pushData">确定</lk-button>
        </div>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';
import loading from '../../components/LoadingSpan.vue';

export default {
  name: 'breakageCreate',
  components: {
    BaseFrame,
    loading,
  },
  data() {
	  const self = this;
    return {
      breakageStatus:1,
      model1:'未申请',
      applyStatusList:[
        {
          id:1,
          value:'未申请',
          label:'未申请'
        },
        {
          id:2,
          value:'已申请',
          label:'已申请',
        },
      ],
      breakageModel: {
        scrapTime: new Date().getTime(),
      },
      breakageRules: {
        scrapTime: [
          { required: true, message: '请选择提报时间' },
        ],
      },
      disabledFromToday: {
        disabledDate: utils.forbiddenDate.disabledFromToday,
      },
      showModal: false,
      modalLoading: false,
      submitLoading: false,
      tempGoods: [],
      queryParams: {},
      modalQueryParams: {
        nameMix: '',
        unqualifiedApplyCode: null,
      },
      statusMap: new Map([
        [1, '启用'],
        [2, '禁用'],
      ]),
      approveStatusMap: new Map([
        [1, '审批中'],
        [2, '审批通过'],
        [3, '审批驳回'],
      ]),
      breakageStatusMap: new Map([
        [1, '未申请'],
        [2, '已申请'],
      ]),
	    scrapReasonTypes: [{
        id: 1,
        name: '药品过期',
      }, {
        id: 2,
        name: '药品损坏',
      }, {
        id: 3,
        name: '药监抽检',
      }, {
        id: 5,
        name: '效期滞销'
      }
      ],
      columns: [
        {
          title: '商品编码',
          key: 'unqualifiedRecordDrugSerialCode',
          minWidth: 110,
        },
        {
          title: '商品名称',
          key: 'unqualifiedRecordGoodsName',
          minWidth: 110,
        },
        {
          title: '通用名称',
          key: 'unqualifiedRecordApprovedDrugNames',
          minWidth: 110,
        },
        { title: '规格', key: 'unqualifiedRecordSpecifications', minWidth: 110 },
        { title: '剂型', key: 'unqualifiedRecordDosageForm', minWidth: 110 },
        { title: '单位', key: 'unqualifiedRecordDrugMiniPackageUnit', minWidth: 110 },
        { title: '仓库', key: 'unqualifiedRecordWarehouseName', minWidth: 110 },
        { title: '货位', key: 'unqualifiedRecordLocationCode', minWidth: 110 },
        { title: '批次', key: 'unqualifiedRecordGoodsBatchSeq', minWidth: 110 },
        { title: '批号', key: 'unqualifiedRecordGoodsBatchNumber', minWidth: 110 },
        {
          title: '成本单价',
          key: 'unqualifiedRecordPriceWithTax',
          minWidth: 110,
        },
        {
          title: '报损金额',
          key: 'unqualifiedRecordUnqualifiedAmount',
          minWidth: 110,
        },
        {
          title: '不含税金额',
          key: 'unqualifiedRecordUnqualifiedAmountWithoutTax',
          minWidth: 110,
        },
        {
          title: '税率',
          key: 'unqualifiedRecordInputTaxRate',
          minWidth: 110,
          render: (h, params) => h('span', `${params.row.unqualifiedRecordInputTaxRate}%`),
        },
        {
          title: '税额',
          key: 'unqualifiedRecordTax',
          minWidth: 110,
        },
        {
          title: '有效期',
          key: 'unqualifiedRecordExpiryDate',
          minWidth: 110,
        },
        {
          title: '入库时间',
          key: 'unqualifiedRecordPurchaseTime',
          minWidth: 110,
        },
        {
          title: '数量',
          key: 'unqualifiedRecordUnqualifiedCount',
          fixed: 'right',
          minWidth: 110,
        },
        {
          title: '报损原因',
          key: 'scrapReason',
          fixed: 'right',
          minWidth: 110,
	        render: (h, params) => {
		        const optionArr = self.scrapReasonTypes.map(item => h('lk-option', {
			        props: {
				        value: item.name,
			        },
		        }, item.name));
		        return h('lk-select',
			        {
				        props: {
					        value: params.row.scrapReason,
					        transfer: true,
				        },
				        on: {
					        'on-change': (value) => {
						        this.tableData[params.row._index].scrapReason = value;
					        },
				        },
			        },
			        optionArr);
	        },
        },
        {
          title: '操作',
          key: 'addBtn',
          minWidth: 100,
          fixed: 'right',
          render: (h, params) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  const index = params.row._index;
                  this.tableData.splice(index, 1);
                },
              },
            }, '删除'),
          ]),
        },
      ],
      tableData: [],
      modalTableData: [],
      modalColumns: [
        {
          title: '选择', key: 'id', type: 'selection', width: 60,
        },
        { title: '不合格单号', key: 'unqualifiedRecordUnqualifiedApplyCode', minWidth: 160 },
        { title: '商品编码', key: 'unqualifiedRecordDrugSerialCode', minWidth: 110 },
        { title: '商品名称', key: 'unqualifiedRecordGoodsName', minWidth: 110 },
        { title: '通用名称', key: 'unqualifiedRecordApprovedDrugNames', minWidth: 110 },
        { title: '助记码', key: 'unqualifiedRecordMnemonicCode', minWidth: 110 },
        { title: '规格', key: 'unqualifiedRecordSpecifications', minWidth: 110 },
        { title: '生产厂家', key: 'unqualifiedRecordManufacturer', minWidth: 110 },
        { title: '商品状态', key: 'unqualifiedRecordGoodsStoreStatusStr', minWidth: 110 },
        { title: '剂型', key: 'unqualifiedRecordDosageForm', minWidth: 110 },
        { title: '单位', key: 'unqualifiedRecordDrugMiniPackageUnit', minWidth: 110 },
        { title: '仓库', key: 'unqualifiedRecordWarehouseName', minWidth: 110 },
        { title: '货位', key: 'unqualifiedRecordLocationCode', minWidth: 110 },
        { title: '批次', key: 'unqualifiedRecordGoodsBatchSeq', minWidth: 110 },
        {
          title: '成本单价',
          key: 'unqualifiedRecordPriceWithTax',
          minWidth: 110,
        },
        {
          title: '报损金额',
          key: 'unqualifiedRecordUnqualifiedAmount',
          minWidth: 110,
        },
        {
          title: '有效期',
          key: 'unqualifiedRecordExpiryDate',
          minWidth: 110,
        },
        {
          title: '入库时间',
          key: 'unqualifiedRecordPurchaseTime',
          minWidth: 110,
        },
        { title: '批号', key: 'unqualifiedRecordGoodsBatchNumber', minWidth: 110 },
        { title: '不合格数量', key: 'unqualifiedRecordUnqualifiedCount', minWidth: 110 },
        { title: '不合格原因', key: 'unqualifiedRecordApplyReason', minWidth: 110 },
        { title: '创建时间', key: 'unqualifiedRecordCreateTime', minWidth: 110 },
        { title: '创建人', key: 'unqualifiedRecordCreateUserName', minWidth: 110 },
        { title: '报损状态',key: 'unqualifiedRecordBreakageStatusStr', minWidth:110 },
      ],
      page: 1,
      size: 10,
      count: 0,
      inventoryIds: [],
    };
  },
  computed: {
    selectedIds() {
      const result = [];
      this.tableData.forEach((item) => {
        result.push(item.unqualifiedRecordId);
      });
      return result;
    },
    selectedTempGoodsIds() {
      const result = [];
      this.tempGoods.forEach((item) => {
        result.push(item.unqualifiedRecordId);
      });
      return result;
    },
    // tempselected(){
    //   const result=[]
    //   this.temp
    // }
  },
  methods: {
    handlerchange(val){
       if(val==='未申请'){
          this.breakageStatus=1
          this.page=1;
          this.tempGoods=[];
       }else{
          this.breakageStatus=2;
          this.page=1;
          this.tempGoods=[];
       }
    },

    // changePage(num) {
    //   this.page = num;
    //   this.getInventoryData();
    // },
    changePage(num){
      const params = utils.deepClone(this.modalQueryParams);
      params.page = num;
      params.size = this.size;
      params.breakageStatus=this.breakageStatus;
      params.approveStatus = 2;
      this.$store.commit('setDisableLoading', true);
      this.modalLoading = true;
      inventory.unqualifiedRecordList(params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.modalTableData = [];
          this.count = count;
          list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.unqualifiedRecordCreateTime = utils.exchangeTime(result.unqualifiedRecordCreateTime);
            result.unqualifiedRecordGoodsStoreStatusStr = this.statusMap.get(result.unqualifiedRecordGoodsStoreStatus);
            result.unqualifiedRecordApproveStatusStr = this.approveStatusMap.get(result.unqualifiedRecordApproveStatus);
            result.unqualifiedRecordBreakageStatusStr = this.breakageStatusMap.get(result.unqualifiedRecordBreakageStatus);
            result._checked = this.selectedIds.includes(result.unqualifiedRecordId) || this.selectedTempGoodsIds.includes(result.unqualifiedRecordId);
            result._disabled = this.selectedIds.includes(result.unqualifiedRecordId);
            result.id = result.unqualifiedRecordId;
            result.unqualifiedRecordExpiryDate = utils.exchangeTime(result.unqualifiedRecordExpiryDate);
            result.unqualifiedRecordPurchaseTime = utils.exchangeTime(result.unqualifiedRecordPurchaseTime);
            this.modalTableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
        this.modalLoading = false;
      }).catch((err) => {
        this.modalLoading = false;
        utils.handleError(err);
      });
    },
    pushData() {
      if (this.tempGoods.length < 0 && this.tableData.length < 0) {
        this.$Message.error('请选择不合格商品');
        return;
      }
      this.tempGoods.forEach((item) => {
        this.tableData.push(item);
      });
      this.tempGoods = [];
      this.hideModal();
    },
    getData() {
      const inventoryIds = this.inventoryIds.split(',');
      this.queryParams.page = this.page;
      this.queryParams.size = this.size;
      this.queryParams.unqualifiedRecordIds = inventoryIds;
      inventory.unqualifiedRecordList(this.queryParams).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.unqualifiedRecordCreateTime = utils.exchangeTime(result.unqualifiedRecordCreateTime);
            result.unqualifiedRecordGoodsProductionDate = utils.exchangeTime(result.unqualifiedRecordGoodsProductionDate);
            result.unqualifiedRecordGoodsExpiryDate = utils.exchangeTime(result.unqualifiedRecordGoodsExpiryDate);
            result.unqualifiedCount = 0;
            result.applyReason = '';
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getInventoryData() {
      const params = utils.deepClone(this.modalQueryParams);
      this.page=1;
      params.page = this.page;
      params.size = this.size;
      params.breakageStatus=this.breakageStatus;
      params.approveStatus = 2;
      this.$store.commit('setDisableLoading', true);
      this.modalLoading = true;
      inventory.unqualifiedRecordList(params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.modalTableData = [];
          this.count = count;
          list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.unqualifiedRecordCreateTime = utils.exchangeTime(result.unqualifiedRecordCreateTime);
            result.unqualifiedRecordGoodsStoreStatusStr = this.statusMap.get(result.unqualifiedRecordGoodsStoreStatus);
            result.unqualifiedRecordApproveStatusStr = this.approveStatusMap.get(result.unqualifiedRecordApproveStatus);
            result.unqualifiedRecordBreakageStatusStr = this.breakageStatusMap.get(result.unqualifiedRecordBreakageStatus);
            result._checked = this.selectedIds.includes(result.unqualifiedRecordId) || this.selectedTempGoodsIds.includes(result.unqualifiedRecordId);
            result._disabled = this.selectedIds.includes(result.unqualifiedRecordId);
            result.id = result.unqualifiedRecordId;
            result.unqualifiedRecordExpiryDate = utils.exchangeTime(result.unqualifiedRecordExpiryDate);
            result.unqualifiedRecordPurchaseTime = utils.exchangeTime(result.unqualifiedRecordPurchaseTime);
            this.modalTableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
        this.modalLoading = false;
      }).catch((err) => {
        this.modalLoading = false;
        utils.handleError(err);
      });
    },
    handleAddGoods() {
      this.showModal = true;
      this.clearModalQuery();
      this.getInventoryData();
      this.tempGoods=[];
    },
    saveBreakageData() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.tableData.length === 0) {
            this.$Message.error('请选择不合格商品');
            return;
          }

          let errorMsg = '';
          const params = [];
          for (let i = 0, len = this.tableData.length; i < len; i++) {
            const item = this.tableData[i];
            if (!item.scrapReason) {
              errorMsg = '请选择报损原因';
              break;
            }
            const param = {};
            param.unqualifiedRecordId = item.unqualifiedRecordId;
            param.inventoryId = item.unqualifiedRecordInventoryId;
            param.scrapQuantity = item.unqualifiedRecordUnqualifiedCount;
            param.scrapReason = item.scrapReason;
            param.scrapTime = this.breakageModel.scrapTime;// .getTime();
            params.push(param);
          }
          if (errorMsg) {
            this.$Message.error(errorMsg);
            return;
          }

          this.submitLoading = true;
          inventory.saveBreakageData({ breakages: params }).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success({
                content: `提交成功-报损单号:${res.data.data}`,
                duration: 10,
                closable: true,
              });
              this.clear();
            } else {
              this.$Message.error(res.data.error);
            }
            this.submitLoading = false;
          }).catch((err) => {
            this.submitLoading = false;
            utils.handleError(err);
          });
        } else {
          this.$Message.error('请按照要求填写');
        }
      });
    },
    handleTempSelect(selection, row) {
      console.log(row);
      if (!this.selectedTempGoodsIds.includes(row.id)) {
        this.tempGoods.push(row);
      }
    },
    handleTempCancel(selection, row) {
      this.tempGoods.forEach((item, index) => {
        console.log(item);
        console.log(row);
        if (item.id === row.id) {
          this.tempGoods.splice(index, 1);
        }
      });
    },
    handleSelectAll(selection) {
      // selection.forEach((item) => {
      //     if (!this.selectedTempGoodsIds.includes(item.id)) {
      //     this.tempGoods.push(item);
      //   }  
      // });
      selection.forEach((item)=>{
        if(!this.selectedIds.includes(item.id)){
            if (!this.selectedTempGoodsIds.includes(item.id)) {
               this.tempGoods.push(item);
            }
        }
      })
    },
    handleSelectAllCancel() {
      this.modalTableData.forEach((good) => {
        for (let i = 0, len = this.tempGoods.length; i < len; i++) {
          if (this.tempGoods[i].id === good.id) {
            this.tempGoods.splice(i, 1);
            break;
          }
        }
      });
    },
    clear() {
      this.$router.go(-1);
    },
    clearModalQuery() {
      this.modalQueryParams = {};
      this.model1='未申请';
      this.breakageStatus=1;
    },
    clearModal() {
      this.hideModal();
      this.clearModalQuery();
      this.modalTableData = [];
    },
    hideModal() {
      this.showModal = false;
      utils.handleBodyOverFlow(this);
    },
    createEmptyLine() {
      this.tableData.push({});
    },
  },
  created() {
    this.inventoryIds = this.$route.params.ids;
    this.page = 1;
    if (this.inventoryIds) {
      this.getData();
    }
  },
};
</script>
<style lang="less" scoped>
.paging{
   display: flex;
   justify-content: center;
   margin-top: 14px;
}
.selectCon{
   width: 250px;
   margin: 0 10px;
}
</style>
